export enum CONTROLLERS {
  Account = 'Account/',
  OnlineReserveTime = 'OnlineReserveTime/',
  user = 'user/',
  Reception = 'Reception/',
  CenterSetting = 'CenterSetting/',
  Patient = 'Patient/',
  DoctorSecretary = 'DoctorSecretary/',
  WaitingVisit = 'WaitingVisit/',
  FavoriteDrugs = 'FavoriteDrugs/',
  FavoriteParaClinics = 'FavoriteParaClinics/',
  SalamatInsurance = 'SalamatInsurance/',
  TaminInsurance = 'TaminInsurance/',
  DoctorService = 'DoctorService/',
  MaterialInsuranceAmount = 'MaterialInsuranceAmount/',
  PrescribeDrug = 'PrescribeDrug/',
  PrescribeLaboratory = 'PrescribeLaboratory/',
  SalamatParameters = 'SalamatParameters/',
  TaminParameters = 'TaminParameters/',
  ReasonForReference = 'ReasonForReference/',
  ReasonForReferenceDrug = 'ReasonForReferenceDrug/',
  ReasonForReferenceParaClinic = 'ReasonForReferenceParaClinic/',
  Departments = 'Departments/',
  Gallery = 'Gallery/',
  InsuranceEntity = 'Insurance/',
  BloodLinesEntity = 'StaticData/',
}
